import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  ScenographieRecyclableType,
  ScenographieRecyclableValues,
  Source,
  SourceValues,
  ValuesScenographyRecyclable,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionScenographyRecyclableDto } from './dto.type';

export class QuestionScenographyRecyclableMapper {
  static dtoToEntity(
    dto: QuestionScenographyRecyclableDto,
  ): ImpactCo2Answer<ValuesScenographyRecyclable> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'SCENOGRAPHY_RECYCLABLE',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        scenographieRecyclableType:
          validateValueInType<ScenographieRecyclableType>(
            dto.scenographieRecyclableType,
            ScenographieRecyclableValues,
          ),
        quantity: Number.parseFloat(dto.quantity.toString()),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesScenographyRecyclable>,
    projectId: number,
  ): Omit<
    QuestionScenographyRecyclableDto,
    'id' | 'userId' | 'score' | 'isExternal'
  > {
    return {
      projectId: projectId,
      sector: answer.sector,
      scenographieRecyclableType: answer.values.scenographieRecyclableType,
      quantity: answer.values.quantity,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
